// RBAC permission registry — mirrors the WP plugin's includes/rbac.php
// (fs_rbac_permissions). Owners (app_metadata.roles includes "owner") implicitly
// hold every permission; staff hold the specific permissions granted to them.

export const PERMISSIONS = {
  'chats.view': 'View Customer Chats',
  'chats.respond': 'Respond To Customer Chats',
  'orders.view': 'View Order History',
  'orders.status.update': 'Modify Order Status',
  'quotes.custom.create': 'Create Custom Quotes',
  'services.gold_items.access': 'Gold & Items Panel Access',
  'services.combat_questing.access': 'Combat & Questing Panel Access',
  'support.live.access': 'Live Customer Support Access',
  'staff.manage': 'Manage Support Team',
  'audit.view': 'View Audit Logs',
  'wishlists.view_all': 'View Global Wishlists',
} as const;

export type Permission = keyof typeof PERMISSIONS;

export const ALL_PERMISSIONS = Object.keys(PERMISSIONS) as Permission[];

/** Permission groups for the staff-management UI (mirrors the owner console). */
export const PERMISSION_GROUPS: { key: string; label: string; perms: Permission[] }[] = [
  { key: 'support', label: 'Live Support', perms: ['chats.view', 'chats.respond', 'support.live.access'] },
  { key: 'orders', label: 'Orders', perms: ['orders.view', 'orders.status.update'] },
  { key: 'quotes', label: 'Custom Quotes', perms: ['quotes.custom.create'] },
  {
    key: 'services',
    label: 'Service Panels',
    perms: ['services.gold_items.access', 'services.combat_questing.access'],
  },
  { key: 'admin', label: 'Administration', perms: ['staff.manage', 'audit.view', 'wishlists.view_all'] },
];

/** Owner short-circuits to all permissions (WP manage_options equivalent). */
export function hasPermission(roles: string[], permissions: string[], perm: Permission): boolean {
  if (roles.includes('owner')) return true;
  return permissions.includes(perm);
}

/** A user is staff if they're an owner or hold any Firstseller permission. */
export function isStaffUser(roles: string[], permissions: string[]): boolean {
  return roles.includes('owner') || roles.some((r) => ['admin', 'support', 'staff'].includes(r)) || permissions.length > 0;
}
